import { render, staticRenderFns } from "./companyprofile.vue?vue&type=template&id=7ca946d2&scoped=true"
import script from "./companyprofile.vue?vue&type=script&lang=js"
export * from "./companyprofile.vue?vue&type=script&lang=js"
import style0 from "./companyprofile.vue?vue&type=style&index=0&id=7ca946d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca946d2",
  null
  
)

export default component.exports